import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { HttpClientModule } from '@angular/common/http';

import { AppComponent } from './app.component';

import { CommonModule, registerLocaleData } from '@angular/common';
// import { SessionTimeoutModalModule } from 'session-timeout-modal';
import { CancelRefundService } from './services/rest-api/cancel-refund.service';
import { TranslatorModule } from './modules/translator/translator.module';
//import { AwlLocaleService, AwlCookieService, AwlServicesModule } from 'aacom-widgets';
import localeESUS from '@angular/common/locales/es-US';
registerLocaleData(localeESUS);
import localeENCA from '@angular/common/locales/en-CA';
registerLocaleData(localeENCA);
import localeFRCA from '@angular/common/locales/fr-CA';
registerLocaleData(localeFRCA);
import localePTBR from '@angular/common/locales/pt';
registerLocaleData(localePTBR);
import { RefundStatusModule } from './modules/refund-status/refund-status.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PipeModule } from './modules/pipe/pipe.module';
import localeESCL from '@angular/common/locales/es-CL';
registerLocaleData(localeESCL);
import localeESCO from '@angular/common/locales/es-CO';
registerLocaleData(localeESCO);
// Start of updates for other Spanish Speaking Countries ADO US 999625.This is the 2nd part of 2 code changes for this
import localeESAR from '@angular/common/locales/es-AR';
registerLocaleData(localeESAR);
import localeESBO from '@angular/common/locales/es-BO';
registerLocaleData(localeESBO);
import localeESCR from '@angular/common/locales/es-CR';
registerLocaleData(localeESCR);
import localeESDO from '@angular/common/locales/es-DO';
registerLocaleData(localeESDO);
import localeESEC from '@angular/common/locales/es-EC';
registerLocaleData(localeESEC);
import localeESSV from '@angular/common/locales/es-SV';
registerLocaleData(localeESSV);
import localeESGT from '@angular/common/locales/es-GT';
registerLocaleData(localeESGT);
import localeESHN from '@angular/common/locales/es-HN';
registerLocaleData(localeESHN);
import localeESMX from '@angular/common/locales/es-MX';
registerLocaleData(localeESMX);
import localeESNI from '@angular/common/locales/es-NI';
registerLocaleData(localeESNI);
import localeESPA from '@angular/common/locales/es-PA';
registerLocaleData(localeESPA);
import localeESPY from '@angular/common/locales/es-PY';
registerLocaleData(localeESPY);
import localeESPE from '@angular/common/locales/es-PE';
registerLocaleData(localeESPE);
import localeESUY from '@angular/common/locales/es-UY';
registerLocaleData(localeESUY);
import localeESPR from '@angular/common/locales/es-PR';
registerLocaleData(localeESPR);
// End of updates for other Spanish Speaking Countries ADO US 999625. This is the 2nd part of 2 code changes for this
import { CapitalizeFirstPipe } from './modules/pipe/capitalizefirst.pipe';
import { WINDOW_PROVIDERS } from 'src/app/models/WindowProvider';
import { StartupService } from './services/utils/startup.service';
import { APP_INITIALIZER } from '@angular/core';
import { BASE_URL } from './models/Url';
import { AnalyticsHandlerService } from './tealium/analytics-handler';
import { ENV } from 'src/app/models/Env';

export function initAppFactory(startupService: StartupService) {
  return () => startupService.getBaseUrl();
}

import '@aileron-web/footer';
import '@aileron-web/header';
import '@aileron/button';
import '@aileron/card';
import '@aileron/date-picker';
import '@aileron/dialog';
import '@aileron/grid';
import '@aileron/icon';
import '@aileron/link';
import '@aileron/list';
import '@aileron/loading';
import '@aileron/notification';
import '@aileron/select';
import '@aileron/tailwind';
import '@aileron/text-input';
import '@aileron/tooltip';

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    CommonModule,
    FormsModule,
    HttpClientModule,
    ReactiveFormsModule,
    AppRoutingModule,
    RefundStatusModule,
    TranslatorModule,
    PipeModule
    //AwlServicesModule.forRoot()
  ],
  providers: [
    CancelRefundService,
    WINDOW_PROVIDERS,
    StartupService,
    {
      provide: APP_INITIALIZER,
      useFactory: initAppFactory,
      deps: [StartupService],
      multi: true
    },
    {
      provide: BASE_URL,
      useFactory: (startupService: StartupService) => startupService.provideBaseUrl(),
      deps: [StartupService]
    },
    {
      provide: ENV,
      useFactory: (startupService: StartupService) => startupService.provideEnvironment(),
      deps: [StartupService]
    },
    AnalyticsHandlerService
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  // providers: [CancelRefundService, AwlLocaleService, AwlCookieService],
  bootstrap: [AppComponent]
})
export class AppModule { }
